export default "__VITE_ASSET__Dw2leQn3__"